import React from 'react';
import type { ContentSectionProps } from './types';
import { Container } from 'react-bootstrap';

export const ContentSection: React.FC<ContentSectionProps> = ({ title, content, anchor }) => {
  return (
    <Container className="content-container" id={anchor}>
      <h3 className="content-header">{title}</h3>
      <div className="content-body">
        {content.map((item, index) => {
          if (typeof item === 'string') {
            const startsNewStep = /^\d+\.\s/.test(item);

            return (
              <React.Fragment key={index}>
                {startsNewStep && index > 0 && <span className="content-step-break" aria-hidden="true" />}
                {item}
              </React.Fragment>
            );
          } else if ('link' in item) {
            return (
              <a target="_blank" rel="noopener noreferrer" key={index} href={item.link}>
                {item.text}
              </a>
            );
          } else if ('list' in item) {
            return (
              <div key={index} className="content-list ms-3 mt-3">
                <ul>
                  {item.list.map((listItem, listItemIndex) => (
                    <li key={listItemIndex}>{listItem}</li>
                  ))}
                </ul>
              </div>
            );
          } else if ('bold' in item) {
            return <strong key={index}>{item.text}</strong>;
          } else if ('imageSrc' in item) {
            return (
              <div key={index}>
                <img src={item.imageSrc} className="content-section-image" alt="" />
              </div>
            );
          }

          return null;
        })}
      </div>
    </Container>
  );
};
